
/*
 * Filename: accordion.js
 * By: J. Nguyen
 * Date: 2/8/23
 *
 * Description: 
 * This 
 *
 */


export default function Accordion(element, optionOverwrites) {

  const elem = element;                       // remember the DOM element that this object is bound to
  let api = {};                               // Object to contain the publicly accessible functions

  // default options
  const defaults = {
    debugMode: false
  };

  // overwrite options based on optionOverwrites
  const options = Object.assign(defaults, optionOverwrites);

  // DOM NODES
  const tabNodes = elem.getElementsByClassName('accordion-panel__tab');
  const tabHeadingNodes = elem.getElementsByClassName('accordion-panel__tab-heading');
  const imageNodes = elem.getElementsByClassName('accordion-panel__image');

  // DATA VARIABLES - private variables
  const activeTabClass = 'tab--active';
  const activeImgClass = 'image--active';

  let activeTabIndex = 0;                         // tracker for which index tab value is active


  init();

  // initilize the module
  function init() {
    debug('insider Accordion init()');

    for (let x = 0; x < tabHeadingNodes.length; x++) {
      tabHeadingNodes[x].addEventListener('click', setActiveTabAndImg);
    }
  }


  // HELPER FUNCTIONS
  //===============================================
  
  // Basic debug function
  function debug(msg) { 
    if (defaults.debugMode) {
      console.log(msg);
    }
  }

  // PRIVATE FUNCTIONS
  //===============================================
  
  // This function will deactivate all tabs and image containers
  function clearTabsAndImgs() {
    debug("inside clearTabsAndImgs()");

    for (let x = 0; x < tabNodes.length; x++) {
      tabNodes[x].classList.remove(activeTabClass);
      imageNodes[x].classList.remove(activeImgClass);
    }

  }
  
  // PUBLIC FUNCTIONS
  //===============================================
  
  // This function will activate the given tab
  function setActiveTabAndImg(event) {
    debug("inside setActiveTabAndImg()");  

    const el = event.target;
    const nearestTab = el.closest('.accordion-panel__tab');

    clearTabsAndImgs();
    nearestTab.classList.add(activeTabClass);
    activeTabIndex = Number(nearestTab.dataset.accordionIndex);
    imageNodes[activeTabIndex].classList.add(activeImgClass);

    debug('activeTabIndex: ' + activeTabIndex);
  }
  
  
  // EXPOSE PUBLIC FUNCTIONS VIA THE API
  // Map all the functions we want to expose for public access
  //===============================================================
  api.setActiveTabAndImg = setActiveTabAndImg;
  return api;

}
